import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import CompPartner from "./components/compPartner.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import PartnerOptions from "../../components/serverList/partnerOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import { getPartnerMap, getGameServerMap, getReasonMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList,
    CompPartner: CompPartner,
    timeDateOptions: timeDateOptions,
    PartnerOptions: PartnerOptions
  },
  name: "payLog",
  data: function data() {
    return {
      partnerList: {},
      partnerArray: [],
      serverList: {},
      reasonList: {},
      orderStatus: [{
        label: "已发货",
        value: 1
      }, {
        label: "所有订单",
        value: 2
      }],
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        status: 2,
        partner_id: ""
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverList = _context.sent;
              _context.next = 5;
              return getReasonMap();
            case 5:
              _this.reasonList = _context.sent;
              _context.next = 8;
              return getPartnerMap();
            case 8:
              _this.partnerList = _context.sent;
              for (index in _this.partnerList) {
                _this.partnerArray.push({
                  partner_id: index,
                  partner_name: _this.partnerList[index]
                });
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};